import React from "react";
import { Link } from "react-router-dom";
import Colors from "../../utils/colors";


function HomeProducts ({d}){
  return (
    <div style={{width:"100%"}}>
      <div className="p-card">
        <div className="flex-center" style={{backgroundColor:Colors.bg2, borderRadius:"4px", padding:"1rem .5rem", margin:"16px"}}>
            <div className="flex-center" style={{height:"16rem",objectFit:"contain",overflow:'hidden', borderRadius:"10px", }}>
                <img
                src={d?.img}
                alt={d?.alt}
                className="card-image" style={{borderRadius:"5px", overflow:'hidden'}}
                />
            </div>
        </div>
        <h3 className="card-title">{d?.product}</h3>
        <p className="card-description">
          {d?.description}
        </p>
        <Link to={d?.link} className="card-link" style={{color:Colors.primary3}}>
          {d?.linktext} →
        </Link>
      </div>
       
    </div>
  );
};

export default HomeProducts;
